var _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from 'react';

var SvgCloud = function SvgCloud(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 104,
    height: 104,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#cloud_svg__clip0_1047_10043)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#cloud_svg__filter0_d_1047_10043)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M90.435 85.75H62.468a1.562 1.562 0 100 3.125h27.967a1.562 1.562 0 100-3.124z",
    fill: "#33BB40"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#cloud_svg__filter1_d_1047_10043)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M41.376 85.75h-27.81a1.562 1.562 0 100 3.125h27.81a1.562 1.562 0 100-3.124z",
    fill: "#33BB40"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#cloud_svg__filter2_d_1047_10043)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M52.617 43.962H40.51a1.562 1.562 0 100 3.125h12.108a1.562 1.562 0 000-3.125z",
    fill: "#33BB40"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#cloud_svg__filter3_d_1047_10043)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M64.778 44.42a1.575 1.575 0 00-1.105-.459c-.412 0-.815.168-1.104.458-.292.29-.458.694-.458 1.105a1.567 1.567 0 001.562 1.562c.411 0 .814-.167 1.105-.458.29-.29.458-.693.458-1.104 0-.411-.167-.814-.458-1.105z",
    fill: "#33BB40"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#cloud_svg__filter4_d_1047_10043)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M59.32 44.42a1.578 1.578 0 00-1.106-.459c-.41 0-.814.168-1.104.458-.29.29-.458.694-.458 1.105 0 .412.167.814.458 1.104.292.29.694.458 1.104.458.411 0 .815-.167 1.107-.458.29-.29.456-.693.456-1.104 0-.411-.166-.814-.456-1.105z",
    fill: "#33BB40"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#cloud_svg__filter5_d_1047_10043)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M52.617 56.46H40.51a1.562 1.562 0 100 3.126h12.108a1.562 1.562 0 100-3.125z",
    fill: "#33BB40"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#cloud_svg__filter6_d_1047_10043)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M64.778 56.918a1.574 1.574 0 00-1.105-.458 1.567 1.567 0 00-1.562 1.562 1.564 1.564 0 002.667 1.105c.29-.29.458-.693.458-1.104 0-.411-.167-.814-.458-1.105z",
    fill: "#33BB40"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#cloud_svg__filter7_d_1047_10043)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M59.32 56.918a1.577 1.577 0 00-1.106-.458c-.41 0-.814.168-1.104.458-.29.29-.458.694-.458 1.105 0 .41.167.814.458 1.104.29.29.694.458 1.104.458.413 0 .815-.167 1.107-.458.29-.29.456-.693.456-1.104 0-.411-.166-.814-.456-1.105z",
    fill: "#33BB40"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#cloud_svg__filter8_d_1047_10043)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M52.617 68.96H40.51a1.562 1.562 0 100 3.125h12.108a1.562 1.562 0 000-3.125z",
    fill: "#33BB40"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#cloud_svg__filter9_d_1047_10043)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M64.779 69.417a1.577 1.577 0 00-1.105-.457c-.412 0-.814.167-1.106.457-.29.29-.456.694-.456 1.105 0 .41.166.814.456 1.104.293.291.694.458 1.106.458.411 0 .815-.167 1.105-.458.29-.29.458-.693.458-1.104 0-.411-.167-.814-.458-1.105z",
    fill: "#33BB40"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#cloud_svg__filter10_d_1047_10043)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M59.319 69.417a1.572 1.572 0 00-1.105-.457c-.41 0-.814.167-1.104.457-.29.29-.458.694-.458 1.105 0 .41.167.814.458 1.104.29.291.694.458 1.105.458a1.568 1.568 0 001.562-1.562c0-.41-.166-.814-.458-1.105z",
    fill: "#33BB40"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#cloud_svg__filter11_d_1047_10043)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M72.33 58.246a7.804 7.804 0 00-3.13-6.25 7.805 7.805 0 003.13-6.25c0-4.307-3.504-7.81-7.811-7.81H39.52c-4.308 0-7.812 3.503-7.812 7.81a7.804 7.804 0 003.13 6.25 7.805 7.805 0 000 12.5 7.805 7.805 0 00-3.13 6.25c0 4.307 3.504 7.81 7.812 7.81h10.916v4.338a4.695 4.695 0 00-3.124 4.418A4.692 4.692 0 0052 92a4.692 4.692 0 004.687-4.688 4.695 4.695 0 00-3.125-4.418v-4.337H64.52c4.307 0 7.812-3.504 7.812-7.812a7.804 7.804 0 00-3.13-6.25 7.805 7.805 0 003.13-6.249zM34.834 45.747a4.692 4.692 0 014.688-4.687h24.998a4.693 4.693 0 014.687 4.687 4.693 4.693 0 01-4.687 4.687H39.52a4.693 4.693 0 01-4.687-4.687zM52 88.875c-.862 0-1.563-.701-1.563-1.562 0-.862.701-1.563 1.563-1.563.861 0 1.562.701 1.562 1.563 0 .861-.7 1.562-1.562 1.562zm17.206-18.13a4.692 4.692 0 01-4.687 4.687H39.52a4.692 4.692 0 01-4.687-4.687 4.692 4.692 0 014.688-4.687h24.998a4.693 4.693 0 014.687 4.687zm-4.687-7.812H39.52a4.692 4.692 0 01-4.687-4.687 4.692 4.692 0 014.688-4.687h24.998a4.693 4.693 0 014.687 4.687 4.693 4.693 0 01-4.687 4.687z",
    fill: "#33BB40"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#cloud_svg__filter12_d_1047_10043)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M88.642 36.193a19.045 19.045 0 00-7.954-6.616A27.04 27.04 0 0055.358 12a26.997 26.997 0 00-17.85 6.734 27.022 27.022 0 00-8.687 15.153c-.243-.011-.485-.017-.726-.017-8.873 0-16.092 7.22-16.092 16.093a16.096 16.096 0 0013.596 15.9 1.563 1.563 0 00.481-3.087c-6.346-.99-10.953-6.378-10.953-12.813 0-7.15 5.818-12.968 12.968-12.968.602 0 1.213.043 1.815.127a1.562 1.562 0 001.764-1.337c1.598-11.778 11.78-20.66 23.685-20.66A23.912 23.912 0 0177.97 31.256c.148.43.475.773.896.943a15.869 15.869 0 0110.006 14.795c0 7.538-5.351 14.104-12.723 15.613a1.562 1.562 0 10.626 3.061c8.82-1.805 15.222-9.658 15.222-18.674 0-3.881-1.16-7.616-3.355-10.801z",
    fill: "#33BB40"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "cloud_svg__filter0_d_1047_10043",
    x: 48.906,
    y: 73.751,
    width: 55.091,
    height: 27.125,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.439216 0 0 0 0 0.807843 0 0 0 0 0.270588 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1047_10043"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_1047_10043",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "cloud_svg__filter1_d_1047_10043",
    x: 0.004,
    y: 73.751,
    width: 54.935,
    height: 27.125,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.439216 0 0 0 0 0.807843 0 0 0 0 0.270588 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1047_10043"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_1047_10043",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "cloud_svg__filter2_d_1047_10043",
    x: 26.947,
    y: 31.962,
    width: 39.233,
    height: 27.125,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.439216 0 0 0 0 0.807843 0 0 0 0 0.270588 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1047_10043"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_1047_10043",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "cloud_svg__filter3_d_1047_10043",
    x: 50.111,
    y: 31.961,
    width: 27.125,
    height: 27.125,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.439216 0 0 0 0 0.807843 0 0 0 0 0.270588 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1047_10043"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_1047_10043",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "cloud_svg__filter4_d_1047_10043",
    x: 44.652,
    y: 31.961,
    width: 27.125,
    height: 27.125,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.439216 0 0 0 0 0.807843 0 0 0 0 0.270588 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1047_10043"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_1047_10043",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "cloud_svg__filter5_d_1047_10043",
    x: 26.947,
    y: 44.461,
    width: 39.233,
    height: 27.125,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.439216 0 0 0 0 0.807843 0 0 0 0 0.270588 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1047_10043"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_1047_10043",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "cloud_svg__filter6_d_1047_10043",
    x: 50.111,
    y: 44.46,
    width: 27.125,
    height: 27.125,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.439216 0 0 0 0 0.807843 0 0 0 0 0.270588 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1047_10043"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_1047_10043",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "cloud_svg__filter7_d_1047_10043",
    x: 44.652,
    y: 44.46,
    width: 27.125,
    height: 27.125,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.439216 0 0 0 0 0.807843 0 0 0 0 0.270588 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1047_10043"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_1047_10043",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "cloud_svg__filter8_d_1047_10043",
    x: 26.947,
    y: 56.96,
    width: 39.233,
    height: 27.125,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.439216 0 0 0 0 0.807843 0 0 0 0 0.270588 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1047_10043"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_1047_10043",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "cloud_svg__filter9_d_1047_10043",
    x: 50.112,
    y: 56.959,
    width: 27.125,
    height: 27.125,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.439216 0 0 0 0 0.807843 0 0 0 0 0.270588 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1047_10043"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_1047_10043",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "cloud_svg__filter10_d_1047_10043",
    x: 44.652,
    y: 56.959,
    width: 27.125,
    height: 27.125,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.439216 0 0 0 0 0.807843 0 0 0 0 0.270588 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1047_10043"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_1047_10043",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "cloud_svg__filter11_d_1047_10043",
    x: 23.709,
    y: 29.935,
    width: 56.622,
    height: 70.064,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.439216 0 0 0 0 0.807843 0 0 0 0 0.270588 0 0 0 0.7 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1047_10043"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_1047_10043",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "cloud_svg__filter12_d_1047_10043",
    x: 0.003,
    y: 0,
    width: 103.994,
    height: 77.882,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.439216 0 0 0 0 0.807843 0 0 0 0 0.270588 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1047_10043"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_1047_10043",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "cloud_svg__clip0_1047_10043"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h104v104H0z"
  })))));
};

export default SvgCloud;